<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Papéis</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Home',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Papéis',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div>
                        <v-btn v-if="$check(['roles.create'])" id="btnNew" type="button" color="primary" elevation="0"
                            @click="createNewRole">Incluir</v-btn>
                    </div>
                </div>

            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            @update:items-per-page="pageSizeChanged" @update:page="pageChanged"
                            :server-items-length="dataList.count" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum cargo encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.created_at`]="{ item }">
                                <span>{{ formatDate(item.created_at) }}</span>
                            </template>

                            <template v-slot:[`item.userType`]="{ item }">
                                <span>{{ item.user_type | enum(dataset.userTypes, 'id', 'name') }}</span>
                            </template>

                            <template v-slot:[`item.name`]="{ item }">
                                <span class="text-uppercase">{{ item.name }}</span>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['roles.update'])" v-on="on" @click="editRole(item)" size="large">
                                                mdi-pencil-outline
                                            </v-icon>
                                        </template>
                                        <span>Editar cargo</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon  v-if="$check(['roles.delete'])" v-on="on" @click="confirmDelete(item)" size="large">
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                        <span>Remover cargo</span>
                                    </v-tooltip>

                                </v-row>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>

                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-dialog v-model="dialogConfirmDelete" max-width="400px">
            <v-card>
                <v-card-title>
                    <v-icon large class="mr-2 error--text">mdi-alert-circle-outline</v-icon>
                    Aviso
                </v-card-title>
                <v-card-text class="pt-4 black--text">
                    Você tem certeza que deseja excluir o cargo: <strong>{{ itemToDelete ? itemToDelete.name : ''
                    }}</strong>?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-1" text @click="dialogConfirmDelete = false">Cancelar</v-btn>
                    <v-btn color="error darken-1" text @click="deleteRole">Excluir</v-btn> </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
// import Vue from "vue";
// import VueLodash from 'vue-lodash'
// import _ from 'lodash';
import axios from 'axios';

import userTypes from "@/common/data/user-types.data"

// import object from "@/common/util/object"

// Vue.use(VueLodash) 

export default {
    name: "RoleList",

    data: () => ({
        dataset: {
            userTypes: userTypes
        },
        dataList: {
            // filter: { 
            //     name: "",
            // },
            headers: [
                { text: "Nome", value: "name" },
                { text: "Tipo de usuário", value: "userType" },
                { text: "Criado Em", value: "created_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],

            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['id'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            },
        },
        dialogConfirmDelete: false,
        itemToDelete: null,
    }),

    created() {
        this.load();
    },

    methods: {
        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load(true);
        },

        formatDate(isoString) {
            if (!isoString) return '';
            const date = new Date(isoString);
            const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
            return date.toLocaleDateString('pt-BR', options);
        },

        async load() {
            this.dataList.loading = true;

            try {
                const params = {
                    page: this.dataList.options.page,
                    limit: this.dataList.options.size,
                    ...this.dataList.filter
                };

                const result = await axios.get('api/v2/roles', { params });

                this.dataList.data = result.data.data;
                this.dataList.count = result.data.total;

            } catch (error) {
                console.log('error ', error);
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        createNewRole() {
            this.$router.push('/papeis/novo');
        },

        editRole(item) {
            this.$router.push(`/papeis/${item.id}`);
        },

        confirmDelete(item) {
            this.itemToDelete = item;
            this.dialogConfirmDelete = true;
        },

        async deleteRole() {
            this.dialogConfirmDelete = false;

            if (!this.itemToDelete) return;

            this.dataList.loading = true;
            await new Promise(resolve => setTimeout(resolve, 500));

            try {
                await axios.delete(`api/v2/roles/${this.itemToDelete.id}`);

                this.$dialog.notify.success(`Cargo excluído com sucesso!`, { position: 'top-right', timeout: 3000 });

                this.load();

            } catch (error) {
                console.error('Erro ao excluir', error);
            } finally {
                this.dataList.loading = false;
                this.itemToDelete = null;
            }
        },
    },
};
</script>
